export default __webpack_public_path__ + "static/g2_red-ce3c9e1ba3b74ad92fed80c251233957.svg";